<template>
    <footer class="embed-footer">
        <div class="footer-centered-content">
            <img src='../../assets/logos/logo.png' alt="Educamais" class="footer-logo"/>
            <p class="producer-text">
                Material Educacional Produzido por: <a href="https://www.unimaisedu.com.br" target="_blank" class="footer-link">Grupo Educamais</a>
            </p>
            <p class="copyright-text">&copy; {{ currentYear }} {{ instituicaoNome }} Todos os direitos reservados.</p>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'EmbedFooter',
    props: {
        instituicaoNome: {
            type: String,
            default: ''
        }
    },
    computed: {
        currentYear() {
            return new Date().getFullYear();
        }
    }
}
</script>

<style scoped src="./EmbedFooter.css" />
